export default __webpack_public_path__ + "static/N0013-6bed72f3869f40f7388de96c7ae097e4.png";